import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatInfraestruturaMinima'
})
export class FormatInfraestruturaMinimaPipe implements PipeTransform {

  transform(value: string): unknown {
    if (!value) {
      return '';
    }

    // Divide as linhas e adiciona a tag <br> entre elas
    const formattedText = value.split('\n').map(line => line.trim()).join('<br>');

    // Retorna o texto formatado dentro de uma tag <p>
    return `<p>${formattedText}</p>`;
  }

}
